import "./active.css";
import axios from "../../../../../axios";
import { toast } from "react-toastify";

const DeleteLiveSession = ({
  setDeleteConfirm,
  data,
  supplementDataHandle,
}) => {
  const handleSupplementDelete = async (data) => {
    try {
      const res = await axios.delete(
        `/api/v1/cm/liveSession/deleteSupplement?supplement_id=${data.supplement}&supplementName=${data.type}`
      );
      if (res.status === 200) {
        toast.success(res.data.message);
        setDeleteConfirm(false);
        // window.location.reload()
        supplementDataHandle();
      }
    } catch (error) {
      console.log(error, "error in deletion");
      toast.error(error.response.data.message);
    } finally {
      setDeleteConfirm(false);
      supplementDataHandle();
    }
  };
  const deletedTypeName = (a) => {
    if (a === "preRead") {
      return "pre-read";
    } else if (a === "bbbLecture") {
      return "Live Lecture";
    } else {
      return a;
    }
  };

  return (
    <div className="published_Deative_transprant_body">
      <div className="published_Deative_preview_container">
        <img
          className="deactive_closeBtn"
          src="/images/cross-circle3.svg"
          alt=""
          onClick={() => setDeleteConfirm(false)}
        />
        <div className="col-12 deactivate_msg">
          {`Are you sure you want to delete this ${deletedTypeName(
            data?.type
          )}?`}
        </div>
        <div className="row col-12 publish_deactive_btnBox">
          <button
            className="btn col-sm-5 my-1 deactive_sure_btn"
            onClick={() => {
              handleSupplementDelete(data);
            }}
          >
            Yes
          </button>
          <button
            className="btn col-sm-5 my-1 deactive_sure_btn"
            onClick={() => setDeleteConfirm(false)}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteLiveSession;
